<template>
  <tr @click="selectProvider(provider)">
    <td>{{ provider.name }}</td>
    <td>
      <img :src="provider.logo" alt=" No logo uploaded." />
    </td>
    <td>
      <p><b>Description: </b>{{ shortDesc }}</p>
      <p><b>Url: </b>{{ provider.url }}</p>
      <p><b>Year Founded: </b>{{ provider.year_founded }}</p>
    </td>
  </tr>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "provider-row",
  props: ["provider", "type"],
  computed: {
    shortDesc: function() {
      if (this.provider.description) {
        return this.provider.description.substring(0, 100) + "...";
      } else {
        return "None";
      }
    }
  },
  methods: {
    ...mapActions({
      fetchProvider: "fetchProviderForEdit"
    }),
    selectProvider: function(provider) {
      var provider_id = undefined;
      if (provider.id) {
        provider_id = provider.id;
      } else {
        provider_id = provider.provider_id;
      }
      this.fetchProvider(provider_id).then(() => {
        if (this.type == "review") {
          this.$store.commit("setReviewMode");
          this.$router.push({ name: "submit" });
        } else if (this.type == "edit") {
          this.$store.commit("setEditMode");
          this.$router.push({ name: "provider" });
        }
      });
    }
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
  width: 100%;
}

td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #eaeaea;
}

tr:hover {
  background-color: #eaeaea;
  cursor: pointer;
}

img {
  height: 100px;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/elements/providerRow.vue